import React from "react";
import { getGrantTypeConfig } from "../grantTypeConfig";
import OverallProgressForm from "../OverallProgressForm";

const OverallProgress = ({ grantType = "sme", ...props }) => {
  const cfg = getGrantTypeConfig(grantType);
  return (
    <OverallProgressForm
      apiBase={cfg.apiBase}
      statusLabel={`Status of Overall ${cfg.label}`}
      {...props}
    />
  );
};

export default OverallProgress;
